import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import bailkolhu from "../../images/LOGOs.png";
import nourish from "../../images/nslogo.svg";
import cororcao from "../../images/Corologo.webp";
import amor from "../../images/amor-logo.png";

function LoginUrl() {
  const navigate = useNavigate();

  return (
    <>
      <div className="w-75 m-auto py-3">
        <div className="d-flex justify-center items-center gap-3">
          <a
            onClick={() => {
              navigate("/nslogin");
            }}
            className="mt-3 text-center bg-white p-2 rounded btn-block"
          >
            <img src={nourish} alt="Loginimage" className="img-fluid" />
          </a>
          <a
            onClick={() => {
              navigate("/");
            }}
            className="mt-3 text-center bg-white p-2 rounded btn-block"
          >
            <img src={bailkolhu} alt="Loginimage" className="img-fluid mt-3" />
          </a>
          <a
            onClick={() => {
              navigate("/coracaologin");
            }}
            className="mt-3 text-center bg-black p-2 rounded btn-block"
          >
            <img src={cororcao} alt="Loginimage" className="img-fluid" />
          </a>{" "}
          <a
            onClick={() => {
              navigate("/amorlogin");
            }}
            className="mt-3 text-center bg-black  p-2 rounded btn-block"
          >
            <img src={amor} alt="Loginimage" className="img-fluid" />
          </a>
        </div>
      </div>
    </>
  );
}

export default LoginUrl;
